module.exports = __webpack_public_path__ + "static/media/a22.54a1c30f.ogg";